module.exports = __webpack_public_path__ + "img/press-released-2.ce579a21.jpeg";